const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'development'
    ? ''
    : 'https://smart-hashtag-generator-api.onrender.com')
).replace(/\/$/, '');

export const getHashtagsFromApi = async (topic, count, setLoading) => {
  setLoading(true);

  try {
    const response = await fetch(`${API_BASE_URL}/api/generate-hashtags`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ topic }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to generate hashtags');
    }

    if (!Array.isArray(data.hashtags)) {
      throw new Error('Unexpected response from hashtag API');
    }

    return data.hashtags.slice(0, count);
  } finally {
    setLoading(false);
  }
};
